import { render, staticRenderFns } from "./AttributesTab.vue?vue&type=template&id=553f51fc"
import script from "./AttributesTab.vue?vue&type=script&lang=js"
export * from "./AttributesTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports